<template>
  <v-card width="400" class="mx-auto mt-5">
    <v-card-title>
      <h1 class="display-1">Login</h1>
    </v-card-title>
    <v-card-text>
      <v-text-field id="username" v-model="input.username" label="Username" autocapitalize="none" prepend-icon="mdi-account-circle" />
      <v-text-field
        id="password"
        v-model="input.password"
        :type="showPassword ? 'text' : 'password'"
        label="Password"
        prepend-icon="mdi-lock"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="showPassword = !showPassword"
      />
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn id="login_button" v-on:click="login()" color="info">Login</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { ICarnegoUser, ISiteGroup } from '../main';

import axios from 'axios';
import VueAxios from 'vue-axios';
import { AxiosResponse } from 'axios';

interface ILoginData {
  username: string;
  password: string;
}

@Component({
  components: {},
})

export default class Login extends Vue {
  public showPassword: boolean = false;
  public input: ILoginData = { username: '', password: '' };

  public async created() {

    const self = this;
    const response = await this.$store.dispatch('verifyToken');

    if (response === true) {
      self.$router.replace({ path: '/' });
      return;
    }
  }

  public get isAuthenticated() {
    return this.$store.getters.isAuthenticated;
  }

  public async login() {
    const self = this;

    if (self.input.username !== '' && self.input.password !== '') {

      const token = await this.$store.dispatch('obtainToken', {
          username: self.input.username.toString(),
          password: self.input.password.toString(),
        });

      const isAuthenticated = self.isAuthenticated;

      if (isAuthenticated && token.length > 0) {
          self.$emit('authenticated', true);

          // redirect_to_homepage(self.$store, self.$router);

          return;
      } else {
          console.log(
            'The username and / or password is incorrect',
        );
      }

    }
  }

//   private async get_default_site_group_for_user(user: ICarnegoUser): Promise<ISiteGroup> {

//     const self = this;

//     let current_site_group: ISiteGroup | undefined = self.$store.getters.CurrentSiteGroup;

//     if (current_site_group !== undefined) {
//       return current_site_group;
//     }

//     // Could be admin here if so the will be no groups defined
//     if (user.is_admin === 'T') {
//       // Just select first site_group by default
//       const all_site_groups: ISiteGroup[] = await self.$store.dispatch('requestSiteGroups');
//       current_site_group = all_site_groups[0];
//     }
//     else {
//       // Pick the first site group configure for user
//       current_site_group = user.site_groups[0];
//     }

//     self.$store.commit('setCurrentSiteGroup', current_site_group);

//     return current_site_group;
//   }
}

</script>

<style scoped>
</style>
